var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound"},[_c('img',{attrs:{"src":require("@/home/assets/pc/search/notFound.svg"),"alt":"notFound"}}),_c('div',{staticClass:"tips",domProps:{"innerHTML":_vm._s(_vm.tips)}})])}
var staticRenderFns = []

export { render, staticRenderFns }